/**
 * Habilidades da IA, como aparecem no painel.
 *
 * Esta lista precisa refletir o que o servidor sabe fazer. Antes ela tinha 12
 * itens enquanto o servidor tinha 34 — o resultado era ferramenta ativa e
 * funcionando que a tela nao desenhava, e que era APAGADA ao salvar.
 *
 * Regras ao mexer aqui:
 * - "value" tem que ser exatamente o nome da ferramenta no servidor
 *   (src/services/IntegrationsServices/AiToolCatalog.ts)
 * - "title" e para quem nunca programou: o dono da clinica, o mecanico
 * - "grupo" so organiza a tela
 */
export const TOOL_CATALOG = [
  // ── Agenda ────────────────────────────────────────────────────────────────
  {
    value: "check_schedule_availability",
    grupo: "Agenda",
    title: "Ver horários livres",
    description: "Consulta os horários disponíveis numa data, já descontando o que está ocupado."
  },
  {
    value: "create_schedule_appointment",
    grupo: "Agenda",
    title: "Marcar horário",
    description: "Agenda o compromisso com o profissional escolhido."
  },
  {
    value: "list_professionals",
    grupo: "Agenda",
    title: "Listar profissionais",
    description: "Mostra quem atende, com os serviços e horários de cada um."
  },
  {
    value: "list_schedule_appointments",
    grupo: "Agenda",
    title: "Ver agenda do dia",
    description: "Lista os compromissos marcados numa data."
  },
  {
    value: "list_user_schedules",
    grupo: "Agenda",
    title: "Listar agendas",
    description: "Mostra quais agendas existem na empresa."
  },
  {
    value: "get_company_schedule",
    grupo: "Agenda",
    title: "Horário de funcionamento",
    description: "Informa os dias e horários em que a empresa atende."
  },
  {
    value: "schedule_message",
    grupo: "Agenda",
    title: "Agendar mensagem",
    description: "Programa uma mensagem para ser enviada em data e hora futuras."
  },

  // ── Cliente ───────────────────────────────────────────────────────────────
  {
    value: "get_contact_info",
    grupo: "Cliente",
    title: "Ver dados do cliente",
    description: "Consulta nome, telefone e e-mail de quem está conversando."
  },
  {
    value: "update_contact_info",
    grupo: "Cliente",
    title: "Salvar dados do cliente",
    description: "Guarda nome, e-mail e outras informações no cadastro. É o que dá memória entre conversas."
  },
  {
    value: "validate_cpf",
    grupo: "Cliente",
    title: "Conferir CPF ou CNPJ",
    description: "Verifica se o documento informado é válido."
  },
  {
    value: "validate_email",
    grupo: "Cliente",
    title: "Conferir e-mail",
    description: "Verifica se o e-mail informado tem formato válido."
  },
  {
    value: "validate_phone",
    grupo: "Cliente",
    title: "Conferir telefone",
    description: "Verifica se o telefone informado é válido e o formata."
  },

  // ── Atendimento ───────────────────────────────────────────────────────────
  {
    value: "execute_command",
    grupo: "Atendimento",
    title: "Transferir ou encerrar",
    description: "Passa o atendimento para um setor, marca etiqueta ou encerra a conversa."
  },
  {
    value: "execute_multiple_commands",
    grupo: "Atendimento",
    title: "Fazer várias ações de uma vez",
    description: "Combina transferência, etiqueta e encerramento numa tacada só."
  },
  {
    value: "pause_bot",
    grupo: "Atendimento",
    title: "Sair de cena",
    description: "Pausa a IA por alguns minutos para uma pessoa assumir a conversa."
  },
  {
    value: "notify_user",
    grupo: "Atendimento",
    title: "Avisar a equipe",
    description: "Manda um aviso na hora para um atendente da equipe."
  },
  {
    value: "jump_to_node",
    grupo: "Atendimento",
    title: "Pular no fluxo",
    description: "Leva a conversa para outro ponto do fluxo — útil para etapas que não podem errar."
  },
  {
    value: "call_flow_builder",
    grupo: "Atendimento",
    title: "Entregar para outro fluxo",
    description: "Sai da IA e passa o atendimento para um fluxo inteiro."
  },

  // ── Conhecimento e integrações ────────────────────────────────────────────
  {
    value: "consultar_base_conhecimento",
    grupo: "Conhecimento e integrações",
    title: "Consultar base de conhecimento",
    description: "Busca a resposta no que você cadastrou. Ligue sempre que houver base."
  },
  {
    value: "list_available_tools",
    grupo: "Conhecimento e integrações",
    title: "Listar minhas integrações",
    description: "Mostra as APIs que você cadastrou em Ferramentas."
  },
  {
    value: "execute_tool",
    grupo: "Conhecimento e integrações",
    title: "Usar minha integração",
    description: "Chama uma API que você cadastrou — o seu sistema, o seu ERP, a sua planilha."
  },

  // ── Mensagens ─────────────────────────────────────────────────────────────
  // ── Venda e entrega ───────────────────────────────────────────────────────
  {
    value: "enviar_material",
    grupo: "Venda e entrega",
    title: "Entregar material",
    description: "Manda ao cliente os arquivos cadastrados. A IA escolhe a hora, nunca o conteúdo."
  },
  {
    value: "enviar_pix",
    grupo: "Venda e entrega",
    title: "Enviar Pix",
    description: "Monta e envia o Pix da oferta cadastrada. A IA nunca digita a chave na conversa."
  },
  {
    value: "send_product",
    grupo: "Venda e entrega",
    title: "Enviar produto",
    description: "Manda nome, preço, descrição e imagens de um produto do catálogo."
  },
  {
    value: "allow_product_resend",
    grupo: "Venda e entrega",
    title: "Permitir reenvio de produto",
    description: "Libera enviar de novo um produto que já foi enviado neste atendimento."
  },
  {
    value: "get_asaas_second_copy",
    grupo: "Venda e entrega",
    title: "Segunda via de boleto",
    description: "Busca no Asaas da empresa a segunda via pelo CPF: linha digitável, link e Pix."
  },
  {
    value: "call_prompt_agent",
    grupo: "Conhecimento e integrações",
    title: "Chamar agente especializado",
    description: "Passa a conversa para outra IA configurada no workflow de IAs."
  },

  {
    value: "format_message",
    grupo: "Mensagens",
    title: "Formatar mensagem",
    description: "Aplica negrito e substitui variáveis na resposta."
  },
  {
    value: "send_location",
    grupo: "Mensagens",
    title: "Enviar localização",
    description: "Manda o endereço no mapa para o cliente."
  },
  {
    value: "send_contact_file",
    grupo: "Mensagens",
    title: "Enviar arquivo do cliente",
    description: "Compartilha um arquivo guardado no cadastro do contato."
  },
  {
    value: "like_message",
    grupo: "Mensagens",
    title: "Reagir à mensagem",
    description: "Responde com uma reação na mensagem do cliente."
  },
  {
    value: "send_emoji",
    grupo: "Mensagens",
    title: "Enviar emoji",
    description: "Responde só com um emoji, quando couber."
  },

  // ── Grupos (só no WhatsApp por QR Code) ───────────────────────────────────
  {
    value: "get_company_groups",
    grupo: "Grupos",
    title: "Listar grupos",
    description: "Mostra os grupos da conexão. Só funciona no WhatsApp por QR Code."
  },
  {
    value: "send_group_message",
    grupo: "Grupos",
    title: "Mandar mensagem em grupo",
    description: "Envia texto para um grupo. Só funciona no WhatsApp por QR Code."
  }
];

/**
 * Opcoes de comportamento — NAO sao ferramentas. A IA nao "chama" nenhuma
 * delas; sao ajustes de como a resposta e montada. Ficavam misturadas com as
 * habilidades e confundiam.
 */
export const COMPORTAMENTOS = [
  {
    value: "auto_variables",
    title: "Variáveis automáticas",
    description: "Troca {{nome}}, {{data}}, {{protocolo}} e outras pelos valores reais na resposta."
  }
];

/** Ferramentas que mexem em dado sensivel e vem desligadas por padrao. */
export const DEFAULT_SENSITIVE_TOOLS = [
  "update_contact_info",
  "create_schedule_appointment",
  "execute_multiple_commands",
  "send_group_message",
  "call_flow_builder"
];

/** Sugestao de habilidades por tipo de negocio, usada pelo gerador. */
export const HABILIDADES_POR_PERFIL = {
  atendimento: [
    "consultar_base_conhecimento",
    "check_schedule_availability",
    "create_schedule_appointment",
    "list_professionals",
    "get_company_schedule",
    "validate_phone",
    "update_contact_info",
    "execute_command"
  ],
  vendas: [
    "consultar_base_conhecimento",
    "get_contact_info",
    "update_contact_info",
    "validate_email",
    "validate_phone",
    "execute_command",
    "notify_user"
  ],
  suporte: [
    "consultar_base_conhecimento",
    "get_contact_info",
    "update_contact_info",
    "execute_tool",
    "list_available_tools",
    "pause_bot",
    "notify_user",
    "execute_command"
  ]
};
